import {
  Directive,
  HostBinding,
} from '@angular/core';

@Directive({
  selector: 'thm-content-header, .thm-content-header, [thm-content-header], [thmContentHeader]',
})
export class ContentHeaderDirective {

  @HostBinding('class.thm-content-header')
  @HostBinding('class.mat-h5')
  protected get classes(): boolean { return true; }

  constructor() { }

}
